var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.registrationSuccess
    ? _c("div", { staticClass: "guest-to-account" }, [
        _c(
          "form",
          {
            ref: "guestToAccountForm",
            staticClass: "guest-to-account__form",
            attrs: { method: "post" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.validateAndSubmit($event)
              }
            }
          },
          [
            _c("div", { staticClass: "guest-to-account__header" }, [
              _c("h3", { staticClass: "guest-to-account__headline" }, [
                _vm._v(_vm._s(_vm.headline))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "guest-to-account__description" }, [
                _vm._v(_vm._s(_vm.description))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "guest-to-account__fields" }, [
              _c("div", { staticClass: "input-unit" }, [
                _c("input", {
                  staticClass: "guest-to-account__email-input",
                  attrs: {
                    type: "email",
                    name: "email",
                    id: "guest-email-" + _vm._uid,
                    readonly: "",
                    disabled: ""
                  },
                  domProps: { value: _vm.guestEmail }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "guest-email-" + _vm._uid } }, [
                  _vm._v(_vm._s(_vm.$translate("Ceres::Template.loginEmail")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "passwordInput",
                  staticClass: "input-unit",
                  attrs: { "data-validate": "password" }
                },
                [
                  _c("popper", {
                    ref: "passwordHint",
                    attrs: { trigger: "focus", placement: "bottom" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "handle",
                          fn: function() {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.password,
                                    expression: "password"
                                  }
                                ],
                                attrs: {
                                  type: "password",
                                  name: "password",
                                  autocomplete: "new-password",
                                  id: "guest-password-" + _vm._uid
                                },
                                domProps: { value: _vm.password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.password = $event.target.value
                                  }
                                }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "title",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.regPasswordHintTitle"
                                    )
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "content",
                          fn: function() {
                            return [
                              _c("ul", { staticClass: "pl-3" }, [
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.regPasswordHintLength"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.regPasswordHintDigit"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.regPasswordHintChar"
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3508694108
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: "guest-password-" + _vm._uid } },
                    [
                      _vm._v(
                        _vm._s(_vm.$translate("Ceres::Template.regPassword")) +
                          "*"
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  attrs: { "data-validate": "ref" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordRepeat,
                        expression: "passwordRepeat"
                      }
                    ],
                    attrs: {
                      type: "password",
                      name: "password-repeat",
                      autocomplete: "new-password",
                      id: "guest-password-repeat-" + _vm._uid,
                      "data-validate-ref": "#guest-password-" + _vm._uid
                    },
                    domProps: { value: _vm.passwordRepeat },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.passwordRepeat = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: "guest-password-repeat-" + _vm._uid } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Ceres::Template.regRepeatPassword")
                        ) + "*"
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.honeypot,
                    expression: "honeypot"
                  }
                ],
                staticClass: "honey",
                attrs: {
                  type: "text",
                  name: "username",
                  autocomplete: "new-password",
                  tabindex: "-1"
                },
                domProps: { value: _vm.honeypot },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.honeypot = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.privacyUrl || _vm.gtcUrl
              ? _c("div", { staticClass: "guest-to-account__privacy" }, [
                  _c(
                    "small",
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.regPrivacyPolicyHint"
                            )
                          ) +
                          "\n                "
                      ),
                      _vm.privacyUrl
                        ? [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.privacyUrl,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.contactPrivacyPolicy"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.privacyUrl && _vm.gtcUrl
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$translate("Ceres::Template.contactAnd")
                                ) +
                                " "
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.gtcUrl
                        ? [
                            _c(
                              "a",
                              { attrs: { href: _vm.gtcUrl, target: "_blank" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate("Ceres::Template.contactGtc")
                                  )
                                )
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "guest-to-account__actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-appearance",
                  attrs: { type: "submit", disabled: _vm.isDisabled }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$translate("Ceres::Template.regRegister")) +
                      "\n                "
                  ),
                  _c("icon", {
                    staticClass: "default-float",
                    attrs: { icon: "user-plus", loading: _vm.isDisabled }
                  })
                ],
                1
              )
            ])
          ]
        )
      ])
    : _c("div", { staticClass: "guest-to-account__result" }, [
        _vm.registrationSuccess
          ? _c("div", { staticClass: "alert alert-success" }, [
              _vm._v("\n        " + _vm._s(_vm.successMessage) + "\n    ")
            ])
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }